module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-150x150-6b0c63f13ca226c56153da729d6ab663.png";